import { render, staticRenderFns } from "./IconSaveLinear.vue?vue&type=template&id=7d21312d&scoped=true"
import script from "./IconSaveLinear.vue?vue&type=script&lang=js"
export * from "./IconSaveLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d21312d",
  null
  
)

export default component.exports